module.exports = __webpack_public_path__ + "static/media/safe_place_for_youth.9a2a995e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/orgs/safe_place_for_youth.jpg
// module id = 742
// module chunks = 0